// These pages put the reader back where they were on their own, from a position they save when a card is tapped
// (a card's offset, a search, a day). The navigation middleware puts them at the top before they mount, and the router
// leaves them alone after, or it would scroll over theirs.
export const SELF_RESTORING_PAGES = new Set([
  'events-eventId-agenda',
  'events-eventId-my-event',
  'events-eventId-speakers',
  'events-eventId-partners',
  'events-eventId-goodies',
  'events-eventId-booth-activities',
  'events-eventId-search',
]);
